import * as React from 'react'
import { Modal, Button } from 'react-bootstrap'

interface StaticModalProps {
	modalName: string
	handleClose?: (modalName: string) => void
	handleButton?: () => void
	title?: string
	closeButtonText?: string
	footer?: boolean
	noFooterBorder?: boolean
	container?: any
}

const StaticModal: React.SFC<StaticModalProps> = (props) => {
	const handleClose = () => {
		if (props.handleClose) {
			props.handleClose(props.modalName)
		}
	}
	const handleButton = props.handleButton || handleClose

	return (
		<Modal
			show
			onHide={handleClose}
			container={props.container}
			aria-labelledby="static-modal"
			enforceFocus={false}
			backdrop="static"
		>
			{props.title && (
				<Modal.Header closeButton={!!props.handleClose} onHide={props.handleClose}>
					<Modal.Title id="static-modal-title">{props.title}</Modal.Title>
				</Modal.Header>
			)}
			<Modal.Body>{props.children}</Modal.Body>
			{props.footer && (
				<Modal.Footer style={{ borderTopWidth: props.noFooterBorder ? '0px' : '1px' }}>
					<Button bsStyle="success" onClick={handleButton}>
						{props.closeButtonText ? props.closeButtonText : 'Close'}
					</Button>
				</Modal.Footer>
			)}
		</Modal>
	)
}

export default StaticModal
